import { useEffect } from 'preact/hooks'

import { CurrencyValueForm } from 'models/apps'
import { Calculation } from 'models/exchange-transfer-calculate'
import { CurrencyInput } from 'models/calculator'

import { formatCurrencyAmount } from 'apps-utils/validate-currency-input'

interface UseSyncExchangeAmountProps {
  exchangeData: Calculation
  activeCurrencyInput: CurrencyInput
  baseValue: CurrencyValueForm
  counterValue: CurrencyValueForm
  setBaseValue: (value: CurrencyValueForm) => void
  setCounterValue: (value: CurrencyValueForm) => void
}

export const useSyncExchangeAmount = ({
  exchangeData,
  activeCurrencyInput,
  baseValue,
  counterValue,
  setBaseValue,
  setCounterValue,
}: UseSyncExchangeAmountProps) => {
  useEffect(() => {
    if (!exchangeData) {
      return
    }

    if (activeCurrencyInput === 'base') {
      const nextCounterValue = formatCurrencyAmount(exchangeData.sold_amount || '0')
      if (nextCounterValue.currentValue !== counterValue.currentValue) {
        setCounterValue(nextCounterValue)
      }
      return
    }

    const nextBaseValue = formatCurrencyAmount(exchangeData.bought_amount || '0')
    if (nextBaseValue.currentValue !== baseValue.currentValue) {
      setBaseValue(nextBaseValue)
    }
  }, [
    exchangeData,
    activeCurrencyInput,
    baseValue.currentValue,
    counterValue.currentValue,
    setBaseValue,
    setCounterValue,
  ])
}
